var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table-view',{ref:"tableList",attrs:{"searchModel":_vm.searchModel,"tableModel":_vm.tableModel,"tableData":_vm.tableData,"pages":_vm.pages,"tableCardTitle":"FX LIST"},on:{"searchChange":_vm.handleSearchChange,"pageChange":_vm.handlePageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }